module.exports = __webpack_public_path__ + "static/media/echo-message.565cf9b3.gif";